<template>
  <div full-height grey-back>
    <v-toolbar flat fixed>
      <v-toolbar-side-icon @click="fn_goBack">
        <v-icon>arrow_back</v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-title class="white--text">Select Language</v-toolbar-title>
    </v-toolbar>

    <div class="hasToolbar">

      <v-subheader>App Language</v-subheader>

      <v-list two-line nopadding>

        <!-- English Option -->
        <v-list-tile @click="fn_changeLanguage('en')">
          <v-list-tile-action>
            <v-icon class="primary-color">{{ $root.selectedLanguage === 'en' ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>English</v-list-tile-title>
            <v-list-tile-sub-title>Use English language</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <!-- Hindi Option -->
        <v-list-tile @click="fn_changeLanguage('hi')">
          <v-list-tile-action>
            <v-icon class="primary-color">{{ $root.selectedLanguage === 'hi' ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>हिन्दी (Hindi)</v-list-tile-title>
            <v-list-tile-sub-title>हिंदी भाषा का उपयोग करें</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <!-- Hinglish Option -->
        <v-list-tile @click="fn_changeLanguage('hinglish')">
          <v-list-tile-action>
            <v-icon class="primary-color">{{ $root.selectedLanguage === 'hinglish' ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Hinglish</v-list-tile-title>
            <v-list-tile-sub-title>Roman script mein Hindi use karein</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>
      </v-list>

      <v-subheader>Apply Language To</v-subheader>

      <v-list two-line nopadding>

        <!-- Invoice Print -->
        <v-list-tile v-if="$root.selectedLanguage !== 'en'">
          <v-list-tile-content>
            <v-list-tile-title>Invoice Print in Selected Language</v-list-tile-title>
            <v-list-tile-sub-title>Render invoice prints in the selected language</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch v-model="$root.invoicePrintInSelectedLanguage" @change="fn_toggleSetting('invoicePrintInSelectedLanguage', $event)" hide-details></v-switch>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider></v-divider>

        <!-- Thermal Print -->
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Thermal Print in Multi Language</v-list-tile-title>
            <v-list-tile-sub-title>Render thermal prints in the multi language</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch v-model="$root.thermalPrintInSelectedLanguage" @change="fn_toggleSetting('thermalPrintInSelectedLanguage', $event)" hide-details></v-switch>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider v-if="$root.selectedLanguage !== 'en'"></v-divider>

        <!-- Share Bill/Invoice -->
        <v-list-tile v-if="$root.selectedLanguage !== 'en'">
          <v-list-tile-content>
            <v-list-tile-title>Bill/Invoice Share Message</v-list-tile-title>
            <v-list-tile-sub-title>Share messages in the selected language</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch v-model="$root.shareInSelectedLanguage" @change="fn_toggleSetting('shareInSelectedLanguage', $event)" hide-details></v-switch>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <!-- Info Card -->
      <v-card flat style="margin: 16px; border-radius: 10px; background: rgba(75, 119, 190, 0.1);">
        <v-card-text style="padding: 16px;">
          <v-icon color="primary" style="margin-right: 8px;">info_outline</v-icon>
          <span style="font-size: 14px;">Changes will be applied across the application.</span>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'language_selection',
  mounted() {
    window.js_globals.fn_onBackPress = this.fn_goBack;
  },
  methods: {
    fn_goBack() {
      this.$router.go(-1);
    },
    fn_changeLanguage(languageCode) {
      this.$loadLocale(languageCode).then(() => {
        this.$root.selectedLanguage = languageCode;
      });

      // localStorage.setItem('appLanguage', languageCode);
      let obj = {language: languageCode};
      this.$root.fn_saveLocalData({LocalKey:'appLanguage',LocalValue:JSON.stringify(obj)});

      var toastMsg = 'Language changed to English';
      if (languageCode === 'hi') toastMsg = 'भाषा हिंदी में बदल दी गई है';
      else if (languageCode === 'hinglish') toastMsg = 'Language Hinglish mein change ho gayi';
      this.showToast(toastMsg);
    },
    fn_toggleSetting(key, value) {
      localStorage.setItem(key, value ? '1' : '0');
    }
  }
};
</script>

<style scoped>
.language-option {
  cursor: pointer;
  transition: all 0.3s ease;
}

.language-option:hover {
  background-color: rgba(75, 119, 190, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/components/settings/language/language_selection.vue